import React from 'react'
import { Navigate } from 'react-router-dom'
import { useDealership } from '../../store/zustand/dealershipStore'

const DefaultDealershipRedirect = () => {
  const dealership = useDealership()
  if (dealership && dealership.id)
    return <Navigate to={dealership.id.toString()} replace />

  return <></>
}

export default DefaultDealershipRedirect
